import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class AppSubmenu extends Component {
  static propTypes = {
    className: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.any),
    onMenuItemClick: PropTypes.func,
    root: PropTypes.bool,
  };

  static defaultProps = {
    className: null,
    items: null,
    onMenuItemClick: null,
    root: false,
  };

  constructor(props) {
    super(props);
    this.state = { activeIndex: null };
  }

  onMenuItemClick(event, item, index) {
    const { onMenuItemClick } = this.props;
    const { activeIndex } = this.state;

    // avoid processing disabled items
    if (item.disabled) {
      event.preventDefault();
      return true;
    }

    // execute command
    if (item.command) {
      item.command({ originalEvent: event, item });
    }

    if (index === activeIndex) {
      this.setState({ activeIndex: null });
    } else {
      this.setState({ activeIndex: index });
    }

    if (onMenuItemClick) {
      onMenuItemClick({
        originalEvent: event,
        item,
      });
    }
    return event;
  }

  // eslint-disable-next-line class-methods-use-this
  renderLinkContent(item) {
    const submenuIcon = item.items && <i className="pi pi-fw pi-angle-down menuitem-toggle-icon" />;
    const badge = !isNaN(item.badge) && <span className="badge">{item.badge}</span>;

    return (
      <div
        className={item.disabled ? "menu-item disabled" : "menu-item"}
      >
        <i className={item.icon} />
        <span>{item.label}</span>
        {submenuIcon}
        {badge}
      </div>
    );
  }

  renderLink(item, i) {
    const content = this.renderLinkContent(item);

    if (item.to) {
      return (
        <NavLink
          activeClassName="active-route"
          to={item.to}
          onClick={(e) => this.onMenuItemClick(e, item, i)}
          exact
          target={item.target}
        >
          {content}
        </NavLink>
      );
    }

    return (
      <a href={item.url} onClick={(e) => this.onMenuItemClick(e, item, i)} target={item.target}>
        {content}
      </a>
    );
  }

  render() {
    const { items, onMenuItemClick, className, root } = this.props;

    const { activeIndex } = this.state;
    const myItems =
      items &&
      items.map((item, i) => {
        const active = activeIndex === i;
        const extraClassess = { 'active-menuitem': active && !item.to };
        const styleClass = classNames(item.badgeStyleClass, extraClassess);

        return (
          // eslint-disable-next-line react/no-array-index-key
          <li className={styleClass} key={i}>
            {items.items && root === true && <div className="arrow" />}
            {this.renderLink(item, i)}
            <AppSubmenu items={item.items} onMenuItemClick={onMenuItemClick} />
          </li>
        );
      });

    return myItems ? <ul className={className}>{myItems}</ul> : null;
  }
}

// eslint-disable-next-line react/no-multi-comp
class AppMenu extends Component {
  static propTypes = {
    model: PropTypes.arrayOf(PropTypes.any),
    onMenuItemClick: PropTypes.func,
  };

  static defaultProps = {
    model: null,
    onMenuItemClick: null,
  };

  render() {
    const { model, onMenuItemClick } = this.props;
    return (
      <div className="menu">
        <AppSubmenu items={model} className="layout-main-menu" onMenuItemClick={onMenuItemClick} root />
      </div>
    );
  }
}

export default AppMenu;
